/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowSportsGameTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowSportsGame,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Cheer for Our Team!",
    "Game Day Excitement!",
    "Sports Fanatic Gather!",
  ],
  title: "Sports Game Day",
  description: "Organize an exciting outing to watch a sports game.",
  longDescription:
    "Plan a thrilling game day. Choose the date, pick a team to support, and decide where to eat before or after the game!",
  emoji: "🏟",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Sports Game Day",
          emoji: "🏟",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we go to the game?",
          emoji: "📅",
          completeAction: {
            question: "Decide on which game to attend?",
            description: "Which game do we want to see?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What game should we attend?",
                emoji: "🏈",
                completeAction: {
                  question: "Decide on where to eat?",
                  description: "Where should we grab a bite before the game?",
                  addModules: [
                    {
                      type: ModuleType.Location,
                      doneType: ModuleDoneType.Voting,
                      title: "Where should we eat?",
                      emoji: "🍔",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Get Ready to Cheer!",
    outroDescription:
      "Your game day plans are set! Enjoy the excitement and fun!",
  },
};
